import { IconArrowDownRegular, IconInfoRegular, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { TouchAccessibilityWrapper } from '@domains/pdp-common';

interface Props {
  benefitBoxOpen: boolean;
  isFetched: boolean;
  sales: number;
  salesColor: string;
  content: string;
  paymentBenefitInfo: {
    content: string;
    card_name: string;
  } | null;
  onClick: () => void;
  onClickInfo: () => void;
}

export const MaximumBenefitSummary = ({
  benefitBoxOpen,
  isFetched,
  sales,
  salesColor,
  content,
  paymentBenefitInfo,
  onClick,
  onClickInfo,
}: Props) => {
  if (!isFetched) {
    return (
      <SkeletonContainer>
        <SkeletonLeft />
        <SkeletonRight />
      </SkeletonContainer>
    );
  }

  return (
    <Container onClick={onClick}>
      <SummaryWrapper>
        <SummaryInfo>
          {Boolean(sales) && (
            <Text variant='Body_18_Bold' color='accentPinkPrimary' style={{ color: salesColor, marginRight: 4 }}>
              {sales}%
            </Text>
          )}
          <Text variant='Body_18_Bold' color='textStrong' style={{ marginRight: 2 }}>
            {content}
          </Text>
          <TouchAccessibilityWrapper
            touchWidth={40}
            touchHeight={40}
            onClick={(e) => {
              e.stopPropagation();
              onClickInfo();
            }}
          >
            <IconInfoRegular color='textTertiary' width={20} height={20} />
          </TouchAccessibilityWrapper>
        </SummaryInfo>
        <ToggleWrapper>
          <Text variant='Body_14_Medium' color='textTertiary'>
            예상 최저가
          </Text>
          <IconArrowDownRegular
            color='textTertiary'
            width={20}
            height={20}
            style={{ transform: benefitBoxOpen ? 'rotate(180deg)' : '' }}
          />
        </ToggleWrapper>
      </SummaryWrapper>
      {paymentBenefitInfo?.content && (
        <Text variant='Body_14_Medium' color='textSecondary' style={{ marginTop: 6 }}>
          {paymentBenefitInfo.content}
        </Text>
      )}
      {paymentBenefitInfo?.card_name && (
        <Text variant='Body_13_Regular' color='textSecondary' style={{ marginTop: 2 }}>
          {paymentBenefitInfo.card_name}
        </Text>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 16px 12px 16px 16px;
`;

const SummaryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SummaryInfo = styled.div`
  display: flex;
  align-items: center;
`;

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const SkeletonContainer = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SkeletonLeft = styled.div`
  width: 30%;
  height: 18px;
  border-radius: 2px;
  background: ${vars.color.fillPrimary};
`;

const SkeletonRight = styled.div`
  width: 20%;
  height: 18px;
  border-radius: 2px;
  background: ${vars.color.fillPrimary};
`;
